module.exports = __webpack_public_path__ + "img/maintenance.b46e8494.svg";